import './genre-card.scss';
